import { AuthMethod, } from "./types";
export class BankIdAuthResponse {
    constructor(response, method) {
        if (!response) {
            throw new Error("Response can not be falsy");
        }
        if (!method) {
            throw new Error("Method can not be falsy");
        }
        this.orderRef = response.orderRef;
        this.qrCodeAsBase64 = response.qrCodeAsBase64;
        this.autoLaunchUrl = response.autoLaunchUrl;
        this.method = method;
    }
    getMethod() {
        return this.method;
    }
    isQrCode() {
        return this.method === AuthMethod.QrCode;
    }
    isSameDevice() {
        return this.method === AuthMethod.SameDevice;
    }
    getOrderRef() {
        return this.orderRef;
    }
    getQrCode() {
        if (!this.isQrCode()) {
            throw new Error("Not qr code response");
        }
        return this.qrCodeAsBase64;
    }
    getAutoLaunchUrl() {
        if (!this.isSameDevice()) {
            throw new Error("Not same device response");
        }
        return this.autoLaunchUrl;
    }
}
